import Cookies from 'js-cookie';

export const handlePageviewBeacon = (callback) => {
    if ( window.hasOwnProperty( '_satellite' ) ) {
        const dataObject = {};
        const _satellite = window._satellite;

        // Note: Not sure why but after talking to Matt Pallansch, setting `window.s` values actually works better and beacon retuns correct value
        // dataObject doesn't actually work correctly

        dataObject.pageName = document.title;

        dataObject.prop5 = document.documentElement.lang === 'en' ? 'eng' : 'spa';
        
        dataObject.prop8 = 'Web Page';

        dataObject.pageURL = window.location.href;

        dataObject.prop1  = window.location.href;

        dataObject.prop31 = window.location.href;

        dataObject.prop55 = window.location.href;

        // dataObject.eVar55 = window.location.href;

        dataObject.prop73 = window.location.href;

        _satellite.track( 'pageview', dataObject );

        // check for any callbacks and run them
        if (callback && callback === 'function') callback();
    }
};
